// extracted by mini-css-extract-plugin
export default {"wrapper":"E1-z","play":"F1-z"};